import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { ISaveAdminComplaint } from 'app/models/admin/admin';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-complaintAdmin',
  templateUrl: './complaintAdmin.component.html',
  styleUrls: ['./complaintAdmin.component.scss']
})

export class ComplaintAdminComponent implements OnInit {

  countySelected: string = '';
  countyList: ISelectItems[] = [];
  showList: boolean = false;
  actionableComplaint: boolean = false;
  searchList: IAdministrativeComplaintView[] = [];
  resultsCount: number = 0;
  filter: string = '';
  businessId: string = '';
  currentComplaint: IAdministrativeComplaintView;
  complaintList: ISelectItems[] = [];
  selectActionList: ISelectItems[] = [];
  selectStatusList: IReportSelectItems[] = [];
  statusList: IReportSelectItems[] = [];
  nonActionableList: ISelectItems[] = [];
  savedComplaints: boolean = false;
  listCount: number = 0;

  selectedViolations: string[] = [];

  warningText: string = 'WARNING: Saving this complaint will remove the following (no longer in use) Nature of Complaint Settings:\n\n  • Unlawful indoor smoking area\n\nPlease select equivalent selections from the list to your left.';

  displayedColumns: string[] = ['complaintId', 'complaintStatus', 'actionable', 'reasonNonActionable',
    'businessName', 'businessActive'];
  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl('', [Validators.maxLength(50), Validators.required, Validators.minLength(3)]),
  });

  complaintForm = new UntypedFormGroup({
    complaintId: new UntypedFormControl({ value: '', disabled: true },),
    complaintDate: new UntypedFormControl({ value: '', disabled: true },),
    complaintComments: new UntypedFormControl(''),
    complaintStatusId: new UntypedFormControl(''),
    actionable: new UntypedFormControl(''),
    warning: new UntypedFormControl(''),
    reason: new UntypedFormControl('')
  });

  ngOnInit(): void {
    this.showList = true;
    this.countyList = this.sharedService.countyDropDownList;
    this.complaintForm.controls['warning'].setValue(this.warningText);
    this.complaintForm.controls['warning'].disable();
    this.complaintForm.controls['complaintId'].disable();
    this.complaintForm.controls['complaintDate'].disable();
    this.complaintForm.controls['complaintComments'].disable();
    this.savedComplaints = false;

    if (this.adminService.complaintId != 0 && this.adminService.complaintSearch != '') {
      this.form.controls['searchText'].setValue(this.adminService.complaintSearch);
      this.getSearchComplaintData();

    }
  }

  getStatuses() {
    this.reportService.getComplaintViolationsList().subscribe({
      next: response => {
        this.selectStatusList = response.filter(x => x.group.name == 'Active');
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Data");
      },
    });

    this.reportService.getComplaintStatusList().subscribe({
      next: response => {
        this.statusList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Violations Data");
      },
    });

    this.adminService.getNonActionable().subscribe({
      next: response => {
        this.nonActionableList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });
  }

  getSearchComplaintData() {
    let searchText = String(this.form.controls['searchText'].value);
    // if (searchText != null && searchText.length < 3) {
    //   this.sharedService.toastr.error("");
    // }
    // else 
    if (this.form.valid) {
      this.adminService.complaintSearch = searchText;
      this.adminService.complaintId = 0;
      this.adminService.getSearchComplaintData(searchText).subscribe({
        next: response => {
          this.searchList = response;
          this.listCount = this.searchList.length;
          this.dataSource.data = this.searchList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          if (response != null) {
            this.resultsCount = this.searchList.length;
          }
          this.showList = true;
        },
        error: e => {
          this.sharedService.toastr.error("Could not get search Complaints");
        },
      });
    }
  }

  rowClick(row: IAdministrativeComplaintView) {
    this.businessId = row.businessId.toString();
    this.selectedViolations = [];
    this.currentComplaint = row;
    let tempList: string[] = row.violationTypeIds != null ? row.violationTypeIds.split(',') : [];
    tempList.forEach(x => {
      let value = x.trim();
      if (this.selectedViolations.find(y => y == value) == null) {
        this.selectedViolations.push(value);
      }
    });
    this.showList = false;
    this.actionableComplaint = row.actionable;
    this.complaintForm.controls['complaintId'].setValue(row.complaintId);
    this.complaintForm.controls['complaintDate'].setValue(row.complaintDate);
    this.complaintForm.controls['complaintComments'].setValue(row.complaintComments);
    this.complaintForm.controls['complaintStatusId'].setValue(row.complaintStatusId.toString());
    this.complaintForm.controls['actionable'].setValue(row.actionable ? 'true' : 'false');
    this.complaintForm.controls['reason'].setValue(row.reasonNonActionableId != null ? row.reasonNonActionableId.toString() : '');
    this.getStatuses();
  }

  isViolationChecked(violation: IReportSelectItems): boolean {
    this.currentComplaint.selectedNatureOfComplaints.find(x => x.trim() == violation.value);

    return this.selectedViolations.includes(violation.value);
  }

  updateActionable(event: string) {
    this.actionableComplaint = event == 'true';
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  check(violation: ISelectItems, event: any) {
    if (event.checked) {
      this.selectedViolations.push(violation.value);
    }
    else {
      this.selectedViolations = this.selectedViolations.filter(x => x != violation.value);
    }
  }

  save() {

    this.selectedViolations = this.selectedViolations.filter(x => x.trim() != '');
    let complaints: ISaveAdminComplaint = {
      complaintId: Number(this.complaintForm.controls['complaintId'].value),
      complaintComments: this.complaintForm.controls['complaintComments'].value,
      complaintStatusId: Number(this.complaintForm.controls['complaintStatusId'].value),
      actionable: this.complaintForm.controls['actionable'].value == 'true' ? true : false,
      selectedNatureOfComplaints: this.selectedViolations,
      reasonNonActionableId: +this.complaintForm.controls['reason'].value
    }

    this.adminService.saveComplaintAdmin(complaints).subscribe({
      next: response => {
        this.currentComplaint.complaintStatusId = complaints.complaintStatusId;
        this.currentComplaint.actionable = complaints.actionable;
        this.currentComplaint.reasonNonActionableId = complaints.reasonNonActionableId.toString();
        this.currentComplaint.selectedNatureOfComplaints = complaints.selectedNatureOfComplaints;
        this.sharedService.toastr.success("Complaint Saved");
        this.savedComplaints = true;
      },
      error: e => {
        this.sharedService.toastr.error("Could not save Complaint");
      },
    });
  }

  cancel() {
    if (this.savedComplaints) {
      this.dataSource.data = [];
      this.form.controls['searchText'].setValue('');
    }
    this.showList = true;
  }

  getCounty(countyId: string): string {
    return this.sharedService.convertCounty(countyId);
  }

  getTypeOfBusiness(typeOfBusinessId: string): string {
    return this.sharedService.getBusinessType(typeOfBusinessId).toString();
  }

}
